// Udhyak — Shared mock data

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_patent-exchange-1/artifacts/vdgo5mzx_Udhyak.jpg";

export const BRAND = {
  name: "Udhyak",
  tagline: "Securing ideas. Nurturing success.",
  hindi: "उद्यक्",
  cin: "U72900DL2025PTC000000",
  phone: "1800-UDHYAK-1",
  email: "hello@udhyak.in",
  whatsapp: "+91 99999 88888",
  offices: [
    { city: "New Delhi", addr: "12, Connaught Place, New Delhi 110001", hours: "Mon–Sat · 10AM–7PM" },
    { city: "Mumbai", addr: "Level 9, BKC, Bandra East, Mumbai 400051", hours: "Mon–Sat · 10AM–7PM" },
    { city: "Bengaluru", addr: "Indiranagar 100ft Rd, Bengaluru 560038", hours: "Mon–Sat · 10AM–7PM" },
  ],
};

export const HERO_IMAGES = {
  innovators: "https://images.unsplash.com/photo-1781246212288-7fa538344718?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBzdGFydHVwJTIwZm91bmRlcnMlMjBtZWV0aW5nJTIwb2ZmaWNlfGVufDB8fHx8MTc4MjQ3Njg4OHww&ixlib=rb-4.1.0&q=85",
  startup: "https://images.unsplash.com/photo-1576485436509-a7d286952b65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBzdGFydHVwJTIwZm91bmRlcnMlMjBtZWV0aW5nJTIwb2ZmaWNlfGVufDB8fHx8MTc4MjQ3Njg4OHww&ixlib=rb-4.1.0&q=85",
  scientistA: "https://images.unsplash.com/photo-1581093577421-f561a654a353?w=1600&q=85",
  scientistB: "https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=1600&q=85",
  lawyerA: "https://images.pexels.com/photos/8730998/pexels-photo-8730998.jpeg?auto=compress&cs=tinysrgb&w=1600",
  lawyerB: "https://images.pexels.com/photos/8112121/pexels-photo-8112121.jpeg?auto=compress&cs=tinysrgb&w=1600",
  signing: "https://images.pexels.com/photos/5668773/pexels-photo-5668773.jpeg?auto=compress&cs=tinysrgb&w=1600",
  inventor: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?w=1600&q=85",
  meeting: "https://images.pexels.com/photos/3760067/pexels-photo-3760067.jpeg?auto=compress&cs=tinysrgb&w=1600",
  handshake: "https://images.pexels.com/photos/3760093/pexels-photo-3760093.jpeg?auto=compress&cs=tinysrgb&w=1600",
  office: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1600&q=85",
};

export const STATS = [
  { value: "12,400+", label: "Patents Filed" },
  { value: "850+", label: "Verified Attorneys" },
  { value: "98%", label: "Grant Success Rate" },
  { value: "28", label: "States Covered" },
];

export const IP_CATEGORIES = [
  { name: "Utility Patent", count: 4820, icon: "Lightbulb", desc: "Protect novel processes, machines, compositions" },
  { name: "Design Patent", count: 1290, icon: "Palette", desc: "Protect the ornamental appearance of products" },
  { name: "Trademark", count: 3640, icon: "Award", desc: "Protect brand name, logo, and identity" },
  { name: "Copyright", count: 2110, icon: "FileText", desc: "Protect creative & literary works" },
  { name: "PCT International", count: 540, icon: "Globe2", desc: "Single international filing across 150+ nations" },
  { name: "Industrial Design", count: 320, icon: "Boxes", desc: "Protect aesthetic/visual aspects of articles" },
];

export const HOW_IT_WORKS = [
  { step: "01", title: "Share Your Innovation", desc: "Tell us about your idea — industry, entity type, language, and a brief description. Takes under 3 minutes." },
  { step: "02", title: "Compare Quotations", desc: "Receive tentative quotes from multiple certified attorneys. Compare price, turnaround, and credentials side-by-side." },
  { step: "03", title: "Schedule & Connect", desc: "Pick your preferred attorney, schedule a free consultation, and kickstart your filing — all from one dashboard." },
  { step: "04", title: "Track to Grant", desc: "Stay updated through every milestone with real-time status, document vault, and milestone alerts till grant." },
];

export const TESTIMONIALS = [
  { quote: "Udhyak helped me file my biotech patent in 11 days. The attorney I matched with had filed 40+ patents in my exact domain.", name: "Dr. Priya Ramaswamy", role: "Founder, BioGenix Labs", city: "Bengaluru", avatar: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?w=200&q=85" },
  { quote: "As a first-time inventor, I was lost. Comparing 4 quotes side-by-side made the decision obvious. Saved me ₹38,000.", name: "Arjun Mehta", role: "Mechanical Engineer", city: "Pune", avatar: "https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=200&q=85" },
  { quote: "We filed 14 patents across our portfolio in 6 months. Their concierge service is genuinely best-in-class.", name: "Kavya Iyer", role: "IP Head, NovaCircuit Semiconductors", city: "Hyderabad", avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&q=85" },
];

export const PARTNERS = ["IIT Bombay", "IIM Ahmedabad", "Startup India", "DPIIT", "NASSCOM", "FICCI"];

export const PROVIDERS = [
  {
    id: "lex-india", premium: true, name: "Lex India IP Associates", tagline: "Full-service IP firm · Est. 2008", location: "New Delhi · Mumbai",
    rating: 4.9, reviews: 412, patentsFiled: 1840, successRate: 97, turnaround: "9-12 days", priceFrom: 18500,
    languages: ["English", "Hindi", "Marathi"], specializations: ["Pharma", "Biotech", "Software"],
    avatar: HERO_IMAGES.lawyerA, verified: true, response: "< 2 hrs",
    bio: "Lex India IP Associates is a tier-1 Intellectual Property firm with 16 years of practice. We specialise in cross-border filings, pharmaceutical and biotech patents, and high-value design protection.",
  },
  {
    id: "innovate-legal", premium: true, name: "Innovate Legal LLP", tagline: "Boutique tech-IP practice", location: "Bengaluru",
    rating: 4.8, reviews: 286, patentsFiled: 920, successRate: 95, turnaround: "7-10 days", priceFrom: 14900,
    languages: ["English", "Hindi", "Kannada"], specializations: ["AI/ML", "Semiconductor", "SaaS"],
    avatar: HERO_IMAGES.lawyerB, verified: true, response: "< 1 hr",
    bio: "Innovate Legal is a boutique firm built for deep-tech startups. We work exclusively with engineering and ML founders to protect novel hardware, models, and methods.",
  },
  {
    id: "patent-mitra", premium: false, name: "Patent Mitra & Co.", tagline: "Most affordable · MSME focused", location: "Pune",
    rating: 4.7, reviews: 198, patentsFiled: 540, successRate: 94, turnaround: "10-14 days", priceFrom: 9800,
    languages: ["English", "Hindi", "Marathi", "Gujarati"], specializations: ["Mechanical", "Consumer Products", "Agritech"],
    avatar: HERO_IMAGES.scientistB, verified: true, response: "< 4 hrs",
    bio: "Patent Mitra is built for MSMEs and individual innovators. Transparent pricing, no surprises, and dedicated handholding through your first filing.",
  },
  {
    id: "anand-rajan", premium: true, name: "Anand & Rajan Advocates", tagline: "Top-rated · Senior Patent Agents", location: "Chennai",
    rating: 5.0, reviews: 167, patentsFiled: 720, successRate: 99, turnaround: "12-15 days", priceFrom: 24500,
    languages: ["English", "Tamil", "Hindi"], specializations: ["Chemistry", "Materials", "Defence"],
    avatar: HERO_IMAGES.scientistA, verified: true, response: "< 3 hrs",
    bio: "Anand & Rajan has been representing inventors before the Indian Patent Office since 1997. Our partners are former examiners with deep procedural expertise.",
  },
  {
    id: "ip-pioneers", premium: false, name: "IP Pioneers Network", tagline: "PAN-India · 40+ attorney bench", location: "Hyderabad · Pune · Kochi",
    rating: 4.6, reviews: 521, patentsFiled: 2200, successRate: 93, turnaround: "8-11 days", priceFrom: 16200,
    languages: ["English", "Hindi", "Telugu", "Malayalam"], specializations: ["EdTech", "FinTech", "HealthTech"],
    avatar: HERO_IMAGES.signing, verified: true, response: "< 2 hrs",
    bio: "IP Pioneers is a distributed bench of 40+ patent agents across 6 cities, optimised for fast turnaround on early-stage software and SaaS filings.",
  },
  {
    id: "shastri-co", premium: true, name: "Shastri & Co. IP Lawyers", tagline: "Heritage firm · Est. 1989", location: "New Delhi",
    rating: 4.9, reviews: 309, patentsFiled: 1620, successRate: 96, turnaround: "11-14 days", priceFrom: 21000,
    languages: ["English", "Hindi", "Bengali"], specializations: ["Defence", "Aerospace", "Mechanical"],
    avatar: HERO_IMAGES.lawyerA, verified: true, response: "< 2 hrs",
    bio: "Shastri & Co. is one of India's oldest IP boutiques, with senior counsel from the erstwhile Patent Office. Trusted by 14 Fortune-India companies for decades.",
  },
  {
    id: "byte-counsel", premium: false, name: "ByteCounsel Legal", tagline: "Tech & data privacy practice", location: "Bengaluru · Mumbai",
    rating: 4.7, reviews: 142, patentsFiled: 410, successRate: 95, turnaround: "8-12 days", priceFrom: 17500,
    languages: ["English", "Hindi"], specializations: ["Software", "Data Privacy", "FinTech"],
    avatar: HERO_IMAGES.scientistB, verified: true, response: "< 3 hrs",
    bio: "ByteCounsel is a digital-first IP practice serving SaaS, fintech, and consumer-tech founders across India and South-East Asia.",
  },
  {
    id: "novamark", premium: true, name: "Novamark Patents", tagline: "Pharma & life-sciences specialists", location: "Hyderabad",
    rating: 4.8, reviews: 234, patentsFiled: 1080, successRate: 97, turnaround: "10-13 days", priceFrom: 22500,
    languages: ["English", "Telugu", "Hindi"], specializations: ["Pharma", "Biotech", "Medical Devices"],
    avatar: HERO_IMAGES.scientistA, verified: true, response: "< 2 hrs",
    bio: "Novamark is led by PhDs in molecular biology and medicinal chemistry, working with India's leading pharma houses and biotech startups.",
  },
  {
    id: "kavi-patents", premium: false, name: "Kavi Patents & Trademarks", tagline: "Friendly firm for first-time filers", location: "Ahmedabad",
    rating: 4.5, reviews: 88, patentsFiled: 290, successRate: 92, turnaround: "11-15 days", priceFrom: 8500,
    languages: ["English", "Hindi", "Gujarati"], specializations: ["MSME", "Consumer Products", "Apparel"],
    avatar: HERO_IMAGES.scientistB, verified: true, response: "< 6 hrs",
    bio: "Kavi Patents has been the trusted IP partner for Gujarat's MSME ecosystem for over 12 years, with the most accessible pricing in the country.",
  },
];

export const PRICING_TIERS = [
  { name: "Starter", price: 0, period: "free forever",
    desc: "For curious innovators exploring their first idea.",
    features: ["1 innovation brief submission", "Up to 3 quotes from attorneys", "Basic patent eligibility check", "Community support"],
    cta: "Start Free", highlight: false },
  { name: "Pro", price: 1499, period: "/month",
    desc: "For startups & solo founders filing actively.",
    features: ["Unlimited innovation briefs", "Quotes from 10+ attorneys", "Priority attorney response (< 1 hr)", "Prior-art search included", "Filing tracker & document vault", "1:1 consultation hours"],
    cta: "Go Pro", highlight: true },
  { name: "Enterprise", price: "Custom", period: "annual",
    desc: "For corporates & institutions filing 10+ patents/year.",
    features: ["Dedicated IP success manager", "Portfolio-level analytics", "Volume-discount rate cards", "PCT international filing support", "Custom SLAs & NDAs", "Whitelabel innovator portal"],
    cta: "Talk to Sales", highlight: false },
];

export const FORM_OPTIONS = {
  entityTypes: ["Individual Innovator", "Student / Researcher", "Startup (DPIIT)", "MSME", "Large Corporate", "Academic Institution"],
  industries: ["Software & AI", "Pharma & Biotech", "Mechanical", "Electronics", "Chemicals", "Consumer Products", "Agritech", "Materials", "Defence", "Other"],
  languages: ["English", "Hindi", "Tamil", "Telugu", "Marathi", "Bengali", "Gujarati", "Kannada", "Malayalam", "Punjabi"],
  cities: ["Delhi NCR", "Mumbai", "Bengaluru", "Hyderabad", "Chennai", "Pune", "Kolkata", "Ahmedabad", "Kochi", "Other"],
  patentTypes: ["Utility Patent", "Design Patent", "Trademark", "Copyright", "PCT International", "Industrial Design"],
};

export const REVIEWS = [
  { name: "Rohit Sharma", role: "CTO, NeuralKart", date: "Nov 2025", rating: 5, body: "Filed our 4th patent with the team. Crisp drafting, zero back-and-forth, and the partner himself attends every milestone call." },
  { name: "Dr. Anita Kapoor", role: "Principal Scientist", date: "Oct 2025", rating: 5, body: "Senior partners are former patent examiners — that insight shaved 2 months off our prosecution timeline." },
  { name: "Vikram Reddy", role: "Founder, AgroSense", date: "Sep 2025", rating: 4, body: "Great service overall, slightly long initial response but the quality of drafting more than made up for it." },
];

// Concierge / Premium services
export const CONCIERGE_SERVICES = [
  { title: "Discovery & Eligibility", desc: "Patentability search, prior-art mapping, claim strategy — done by senior IP counsel in 5 days.", icon: "Search" },
  { title: "Drafting & Filing", desc: "End-to-end drafting of provisional & complete specs. Filing at IPO, USPTO, EPO, or PCT.", icon: "FileText" },
  { title: "Office-Action Responses", desc: "Every examiner objection answered by experienced agents. Tracked in your dashboard.", icon: "Reply" },
  { title: "Grant & Renewal", desc: "Annual renewal alerts, payment automation, status sync across jurisdictions.", icon: "ShieldCheck" },
  { title: "Portfolio Management", desc: "Centralised dashboard for all your IP assets — granted, pending, expired, renewed.", icon: "LayoutDashboard" },
  { title: "Strategy Reviews", desc: "Quarterly sessions with senior IP counsel to align IP roadmap with product roadmap.", icon: "TrendingUp" },
];

export const CONCIERGE_TIERS = [
  { name: "Essential", price: "₹29,500", per: "/ filing", best: false,
    feat: ["Eligibility + prior-art search", "Provisional drafting", "Filing at IPO", "Email support", "30-day status tracking"] },
  { name: "Concierge", price: "₹69,000", per: "/ filing", best: true,
    feat: ["Everything in Essential", "Complete specification drafting", "Examiner-objection responses", "Senior counsel touchpoints", "Real-time dashboard", "Renewal automation"] },
  { name: "Founder's Office", price: "₹2,49,000", per: "/ year retainer", best: false,
    feat: ["Up to 5 filings annually", "Dedicated IP manager", "Quarterly strategy reviews", "Cross-border (PCT, US, EU) included", "Litigation advisory hotline", "Whitelabel monthly reports"] },
];

// B2B / Enterprise
export const ENTERPRISE_BENEFITS = [
  { title: "Dedicated IP Success Manager", desc: "A single point of contact across your portfolio." },
  { title: "Volume-Discount Rate Cards", desc: "Up to 35% off list pricing for 100+ filings/year." },
  { title: "Whitelabel Innovator Portal", desc: "Your internal R&D teams submit ideas through your branded interface." },
  { title: "Custom SLAs & NDAs", desc: "MSA structured around your legal, security, and procurement standards." },
  { title: "Portfolio Analytics", desc: "Tableau-style dashboards on filings, grants, geo coverage, and competitor IP." },
  { title: "PCT International Coverage", desc: "Single-vendor solution across 150+ jurisdictions with local counsel." },
];

export const ENTERPRISE_LOGOS = ["Tata Innovate", "Infosys Research", "Mahindra R&D", "Wipro Labs", "TCS Innovation Hub", "Reliance Jio Platforms"];

export const ENTERPRISE_CASE_STUDIES = [
  { logo: "Tata Innovate", patents: 142, savings: "₹78L", desc: "Consolidated 7 external vendors into a single Udhyak engagement; cut average filing turnaround from 38 to 11 days." },
  { logo: "Infosys Research", patents: 96, savings: "₹54L", desc: "Whitelabel portal for 4,000+ engineers; 3.2× increase in invention disclosures filed within 12 months." },
  { logo: "Mahindra R&D", patents: 84, savings: "₹41L", desc: "Quarterly IP-strategy reviews mapped 200+ ideas to a portfolio plan; 92% grant rate in 18 months." },
];

// FAQs (used across pages)
export const FAQS = [
  { q: "How much does it cost to file a patent in India?", a: "On Udhyak, attorney fees start at ₹8,500 for utility patents. Government filing fees are separate (₹1,600–₹8,000 depending on entity type). Quotes are all-inclusive on our marketplace." },
  { q: "How long does grant typically take?", a: "Indian Patent Office grant currently averages 24–36 months from filing. Drafting + filing on Udhyak typically takes 7–14 days." },
  { q: "Will my idea be kept confidential?", a: "Absolutely. Every brief is held under NDA. Attorneys sign confidentiality agreements before reviewing any details and funds are held in escrow till delivery." },
  { q: "Can I file internationally?", a: "Yes — Udhyak attorneys can file PCT international applications, USPTO, EPO, and national-phase entries across 150+ jurisdictions." },
  { q: "What if I'm not satisfied?", a: "We offer a milestone-based escrow model. If an attorney misses a committed milestone, funds remain protected and you can switch to another attorney without penalty." },
];

export const NUDGES = [
  "Talk to a senior IP expert — free 30-min consultation, no commitment.",
  "Not sure where to begin? Book a free discovery call with our concierge team.",
  "Bring your idea, leave with a plan. Schedule a 1:1 call with our IP advisors.",
  "Have questions? A real human is available in your time zone. Book now.",
];

// ============ PORTAL / DASHBOARD MOCK DATA ============

export const CUSTOMER = {
  name: "Ananya Krishnan",
  phone: "+91 98765 43210",
  email: "ananya@brightspark.in",
  entity: "Startup (DPIIT)",
  company: "BrightSpark Innovations Pvt Ltd",
  city: "Bengaluru",
  industry: "Software & AI",
  languages: ["English", "Tamil", "Hindi"],
  avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&q=85",
  memberSince: "Aug 2025",
  plan: "Pro",
};

// A customer's submitted patents with status timelines
export const MY_PATENTS = [
  {
    id: "UDK-2025-0412",
    title: "AI-powered crop disease detection system",
    type: "Utility Patent",
    industry: "Software & AI",
    submitted: "12 Nov 2025",
    stage: "Under Prosecution",
    stageIndex: 3,
    attorney: "Lex India IP Associates",
    attorneyId: "lex-india",
    quote: 18500,
    nextAction: "Examiner FER response due 18 Dec",
    statusColor: "amber",
  },
  {
    id: "UDK-2025-0388",
    title: "Modular solar-thermal cold-storage container",
    type: "Design + Utility",
    industry: "Agritech",
    submitted: "28 Oct 2025",
    stage: "Filed at IPO",
    stageIndex: 2,
    attorney: "Patent Mitra & Co.",
    attorneyId: "patent-mitra",
    quote: 21500,
    nextAction: "Awaiting publication (18 months)",
    statusColor: "teal",
  },
  {
    id: "UDK-2025-0501",
    title: "Federated learning protocol for clinical data privacy",
    type: "Utility Patent",
    industry: "HealthTech",
    submitted: "3 Dec 2025",
    stage: "Comparing Quotes",
    stageIndex: 1,
    attorney: "—",
    attorneyId: null,
    quote: null,
    nextAction: "4 new quotes received — compare now",
    statusColor: "lime",
  },
  {
    id: "UDK-2024-0210",
    title: "Low-power acoustic predictive-maintenance sensor",
    type: "Utility Patent",
    industry: "IIoT",
    submitted: "14 Feb 2024",
    stage: "Granted",
    stageIndex: 4,
    attorney: "Anand & Rajan Advocates",
    attorneyId: "anand-rajan",
    quote: 24500,
    nextAction: "Renewal due Feb 2027",
    statusColor: "green",
  },
];

export const PATENT_STAGES = ["Submitted", "Comparing Quotes", "Filed at IPO", "Under Prosecution", "Granted"];

// Attorney dashboard — logged-in firm
export const FIRM = {
  name: "Innovate Legal LLP",
  contact: "Aakanksha Singh",
  designation: "Managing Partner",
  phone: "+91 90000 12345",
  email: "aakanksha@innovatelegal.in",
  city: "Bengaluru",
  established: 2016,
  attorneys: 8,
  avatar: "https://images.pexels.com/photos/8112121/pexels-photo-8112121.jpeg?auto=compress&cs=tinysrgb&w=400",
  verificationStatus: "Approved",
  tier: "Premium Profile",
  specializations: ["AI/ML", "Semiconductor", "SaaS"],
  languages: ["English", "Hindi", "Kannada"],
  rating: 4.8,
  reviews: 286,
  patentsFiled: 920,
  priceFrom: 14900,
};

export const FIRM_LEADS = [
  { id: "LD-8841", customer: "Ananya Krishnan", entity: "Startup (DPIIT)", patent: "AI crop disease detection", type: "Utility", city: "Bengaluru", date: "12 Dec 2025", status: "Appointment scheduled", appt: "16 Dec · 2:00 PM", value: 18500 },
  { id: "LD-8836", customer: "Rahul Nair", entity: "Individual", patent: "Smart irrigation controller", type: "Utility", city: "Kochi", date: "11 Dec 2025", status: "New lead", appt: "—", value: 15200 },
  { id: "LD-8829", customer: "Meera Joshi", entity: "MSME", patent: "Biodegradable packaging film", type: "Utility", city: "Pune", date: "9 Dec 2025", status: "Quote sent", appt: "—", value: 16800 },
  { id: "LD-8815", customer: "NovaCircuit Semiconductors", entity: "Large Corporate", patent: "Edge-ML inference accelerator", type: "Utility", city: "Hyderabad", date: "6 Dec 2025", status: "Appointment scheduled", appt: "18 Dec · 11:30 AM", value: 22400 },
  { id: "LD-8802", customer: "Dr. S. Venkatesh", entity: "Professor", patent: "Transformer attention compression", type: "Utility", city: "Chennai", date: "2 Dec 2025", status: "Filing in progress", appt: "Completed", value: 19900 },
];

// Admin dashboard
export const ADMIN = { name: "Priyansh Gupta", role: "Platform Admin", avatar: "https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=200&q=85" };

export const ADMIN_STATS = [
  { label: "Total leads (30d)", value: "1,284", delta: "+18%", up: true },
  { label: "Active attorneys", value: "852", delta: "+12", up: true },
  { label: "Pending approvals", value: "14", delta: "5 new", up: false },
  { label: "Appointments booked", value: "438", delta: "+9%", up: true },
];

export const ADMIN_LEADS = [
  { id: "LD-8841", customer: "Ananya Krishnan", entity: "Startup (DPIIT)", patent: "AI crop disease detection", attorney: "Lex India IP Associates", date: "12 Dec 2025", appt: "16 Dec · 2:00 PM", status: "Scheduled", value: 18500 },
  { id: "LD-8836", customer: "Rahul Nair", entity: "Individual", patent: "Smart irrigation controller", attorney: "—", date: "11 Dec 2025", appt: "—", status: "New", value: 15200 },
  { id: "LD-8829", customer: "Meera Joshi", entity: "MSME", patent: "Biodegradable packaging film", attorney: "Patent Mitra & Co.", date: "9 Dec 2025", appt: "—", status: "Quote sent", value: 16800 },
  { id: "LD-8815", customer: "NovaCircuit Semiconductors", entity: "Large Corporate", patent: "Edge-ML inference accelerator", attorney: "Innovate Legal LLP", date: "6 Dec 2025", appt: "18 Dec · 11:30 AM", status: "Scheduled", value: 22400 },
  { id: "LD-8807", customer: "Farmly Agritech", entity: "Startup (DPIIT)", patent: "Soil-nutrient optical scanner", attorney: "IP Pioneers Network", date: "4 Dec 2025", appt: "20 Dec · 4:00 PM", status: "Scheduled", value: 16200 },
  { id: "LD-8802", customer: "Dr. S. Venkatesh", entity: "Professor", patent: "Transformer attention compression", attorney: "Innovate Legal LLP", date: "2 Dec 2025", appt: "Completed", status: "Filing", value: 19900 },
];

export const ADMIN_APPROVALS = [
  { id: "AP-231", firm: "Deccan IP Partners", contact: "Vivek Rao", city: "Hyderabad", changeType: "New onboarding", submitted: "12 Dec 2025", years: "12 years", specs: ["Pharma", "Chemistry"], attorneys: 6, docs: "Verified", avatar: "https://images.pexels.com/photos/8730998/pexels-photo-8730998.jpeg?auto=compress&cs=tinysrgb&w=400" },
  { id: "AP-230", firm: "Anand & Rajan Advocates", contact: "Dr. R. Anand", city: "Chennai", changeType: "Profile edit — pricing", submitted: "11 Dec 2025", years: "27 years", specs: ["Chemistry", "Materials", "Defence"], attorneys: 11, docs: "Verified", avatar: "https://images.unsplash.com/photo-1581093577421-f561a654a353?w=400&q=85" },
  { id: "AP-229", firm: "Coastal Patents LLP", contact: "Sunita Menon", city: "Kochi", changeType: "New onboarding", submitted: "10 Dec 2025", years: "8 years", specs: ["Marine Tech", "Mechanical"], attorneys: 3, docs: "Pending", avatar: "https://images.pexels.com/photos/8112121/pexels-photo-8112121.jpeg?auto=compress&cs=tinysrgb&w=400" },
  { id: "AP-228", firm: "Vindhya IP Chambers", contact: "Amit Sethi", city: "Indore", changeType: "New onboarding", submitted: "9 Dec 2025", years: "15 years", specs: ["Consumer Products", "Design"], attorneys: 5, docs: "Verified", avatar: "https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=400&q=85" },
];

